/**
 * Evento global de sessão expirada (AC-43b): o interceptor de 401 dispara e o
 * `App` escuta para levar a T1 com "Sua sessão expirou" e voltar à rota de origem.
 */
export const SESSION_EXPIRED_EVENT = 'session-expired';

export interface SessionExpiredDetail {
  /** Rota em que o usuário estava, para voltar depois do login. */
  retornoPara: string;
  /** `sessao_expirada` (a sessão venceu) ou `nao_autenticado` (nunca teve). */
  code: 'sessao_expirada' | 'nao_autenticado';
}

export type SessionExpiredEvent = CustomEvent<SessionExpiredDetail>;

/** Rota atual (path + query + hash), sem o host. */
export function currentRoute(): string {
  if (typeof window === 'undefined') return '/';
  const { pathname, search, hash } = window.location;
  return `${pathname}${search}${hash}` || '/';
}

export function emitSessionExpired(detail: SessionExpiredDetail): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT, { detail }));
}

export function onSessionExpired(handler: (detail: SessionExpiredDetail) => void): () => void {
  const listener = (e: Event) => handler((e as SessionExpiredEvent).detail);
  window.addEventListener(SESSION_EXPIRED_EVENT, listener);
  return () => window.removeEventListener(SESSION_EXPIRED_EVENT, listener);
}
